export default __webpack_public_path__ + "static/media/cross copy.31de929e.svg";